var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"conBox",class:[_vm.overStyle=='2'?'overHandle2':'',_vm.overStyle=='3'?'overHandle3':''],style:({fontSize:_vm.fontSize,color:_vm.color,lineHeight:_vm.lineHeight,height:_vm.height})},[_vm._v(" "+_vm._s(_vm.item)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }